import axios from "axios";
import { getToken } from "@/auth/authConfig";
import { getBackendApiUrl } from "./appConfig";

const apiClient = axios.create({
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add token to every request
apiClient.interceptors.request.use(
  async (config) => {
    try {
      const token = await getToken();
      if (token) {
        config.headers = config.headers || {};
        // Send oidc-token header for JWT verification
        config.headers["oidc-token"] = token;
      }
    } catch (error) {
      console.error("Token acquisition failed:", error);
      // Continue with request even if token fails
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.error("Unauthorized - Token may be expired");
      // Could trigger re-authentication here
    }
    return Promise.reject(error);
  }
);

export const apiService = {
  get: (url, config) => apiClient.get(url, config),
  post: (url, data, config) => apiClient.post(url, data, config),
  put: (url, data, config) => apiClient.put(url, data, config),
  patch: (url, data, config) => apiClient.patch(url, data, config),
  delete: (url, config) => apiClient.delete(url, config),
};

export default apiClient;
